import { ButtonAppearance, ButtonVariant, Buttons } from "../ButtonAppearances";
import { ButtonSize } from "../ButtonSize";

/**
 * Gets the button appearance for a given appearance string and size.
 * @param appearance The appearance.
 * @param transparent Whether to render with a transparent background.
 * @param size The size.
 * @returns The button appearance.
 */
export function getAppearanceForString(
  appearance: "primary" | "positive" | "secondary" | "text" | "destructive",
  transparent: boolean,
  size: ButtonSize,
): ButtonAppearance {
  let variant: ButtonVariant;

  switch (appearance) {
    default:
    case "primary":
    case "positive":
      variant = transparent ? Buttons.Functional.Secondary : Buttons.Functional.Primary;
      break;
    case "secondary":
      variant = Buttons.Functional.Secondary;
      break;
    case "text":
      variant = Buttons.Functional.Tertiary;
      break;
    case "destructive":
      variant = transparent ? Buttons.Destructive.Secondary : Buttons.Destructive.Primary;
      break;
  }

  switch (size) {
    default:
    case "large":
      return variant.Large;
    case "small":
      return variant.Small;
    case "compact":
      return variant.Compact;
  }
}
